import React from "react";
import Icon from "../../components/AppIcon";
import Button from "../../components/ui/Button";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCmsService } from "redux/services/general_service";

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { storeInfo, cms } = useSelector((state) => state.general);

  const contactInfo = {
    phone: "07733335662",
    email: "rahiiq@gmail.com",
    facebook: "",
    instagram: "",
  };

  const footerCmsLinks = [
    { type: "privacy_policy", label: "سياسة الخصوصية" },
    { type: "about_us", label: "من نحن" },
    { type: "contact_us", label: "تواصل معنا" },
    { type: "terms_and_conditions", label: "الشروط والأحكام" },
    { type: "return_policy", label: "سياسة الاسترجاع" },
  ];

  const handleSocialClick = (url) => {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlePhoneClick = () => {
    window.open(`tel:${contactInfo.phone}`, "_self");
  };

  const handleEmailClick = () => {
    window.open(`mailto:${contactInfo.email}`, "_blank", "noopener,noreferrer");
  };

  const cmsRoutes = {
    privacy_policy: "/privacy_policy",
    about_us: "/about_us",
    contact_us: "/contact_us",
    terms_and_conditions: "/terms_and_conditions",
    return_policy: "/return_policy",
  };

  const handleCmsLinkClick = (type) => {
    const route = cmsRoutes[type] ;
    window.open(route, "_blank");
  };

  return (
    <footer className="w-full bg-[#F5F3ED] border-t border-[#E6E2D9] pt-10 pb-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto space-y-12">
        {/* ================= NEWSLETTER ================= */}
        <div className="bg-global-text4 rounded-2xl p-6 sm:p-8 lg:p-10">
          <div className="flex flex-col lg:flex-row lg:items-center gap-6">
            <h3 className="text-base sm:text-xl lg:text-2xl font-bold text-global-text8 lg:w-1/3">
              {t("register_now")}
            </h3>
            <div className="flex flex-col sm:flex-row gap-3 w-full lg:flex-1">
              <input
                type="email"
                placeholder={t("emailPlaceholder")}
                className="flex-1 border border-global-text7 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-global-text4"
              />
              <Button
                variant="primary"
                className="bg-[#003459] text-white rounded-lg px-6 py-3 w-full sm:w-auto"
              >
                {t("subscribe")}
              </Button>
            </div>
          </div>
        </div>

        {/* ================= NAV + SOCIAL ================= */}
        <div className="border-b border-global-2 pb-8">
          <div className="flex flex-col lg:flex-row justify-between gap-8">
            {/* Links */}
            <div className="flex flex-col sm:flex-row flex-wrap gap-6 sm:gap-10 text-sm sm:text-base">
              <button
                onClick={() => navigate("/")}
                className="hover:text-global-text4 transition"
              >
                {t("navigation.home")}
              </button>
              <button
                onClick={() => navigate("/product-listing")}
                className="hover:text-global-text4 transition"
              >
                {t("navigation.categories")}
              </button>
              <button
                onClick={() => navigate("/about-us")}
                className="hover:text-global-text4 transition"
              >
                {t("navigation.aboutUs")}
              </button>
            </div>

            {/* Social Icons */}
            <div className="flex items-center gap-6">
              <img
                src="assets/images/facebook.svg"
                className="w-6 h-6 cursor-pointer hover:opacity-80"
                alt="Facebook"
                onClick={() => handleSocialClick(contactInfo.facebook)}
              />
              <div
                className="cursor-pointer hover:opacity-80"
                onClick={handleEmailClick}
              >
                <Icon name="Email" size={20} />
              </div>
              <img
                src="assets/images/instagram.svg"
                className="w-6 h-6 cursor-pointer hover:opacity-80"
                alt="Instagram"
                onClick={() => handleSocialClick(contactInfo.instagram)}
              />
              <div
                className="cursor-pointer hover:opacity-80"
                onClick={handlePhoneClick}
              >
                <Icon name="Phone" size={20} />
              </div>
            </div>
          </div>
        </div>

        {/* ================= CMS Links ================= */}
        <div className="flex flex-wrap justify-center lg:justify-start gap-6 text-sm sm:text-base">
          {footerCmsLinks.map(({ type, label }) => (
            <button
              key={type}
              onClick={() => handleCmsLinkClick(type)}
              className="hover:text-global-text4 transition font-medium"
            >
              {label}
            </button>
          ))}
        </div>

        {/* ================= BOTTOM ================= */}
        <div className="flex flex-col lg:flex-row justify-between items-center gap-6 text-center lg:text-left mt-6">
          <span className="text-sm text-global-text6">{t("footerText")}</span>
          <img
            src="assets/images/logo.png"
            className="w-20 h-auto"
            alt="Logo"
          />
          <span className="text-sm text-global-text6">
            {t("privacyProtected")}
          </span>
        </div>

        {/* ===== Developer Credit ===== */}
        <div className="mt-6 text-center text-xs text-gray-500">
          Made with <span className="text-red-500">❤️</span> by{" "}
          <span className="font-semibold">DevOra</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
